import { user } from 'core';
import { ChooseCycle } from '../ChooseCycle';
import { FeedbackMessage } from '../FeedbackMessage';

const ExtendedCaptation = () => {
  const {
    data: { avaliableCycles },
  } = user.hooks.useUser();

  return (
    <div data-testid="extended-captation">
      {avaliableCycles.status === '' ? <ChooseCycle /> : <FeedbackMessage />}
    </div>
  );
};

export default ExtendedCaptation;
